import { useEffect } from 'react'
import { copyTextToClipboard } from 'react-common'

export const useHandleArticleAnchor = (content: string) => {
  useEffect(() => {
    const elements = [...document.getElementsByClassName('heading-anchor')]

    function copyLink(this: HTMLElement) {
      const anchorId = this.dataset.anchorId

      const href = window.location.href
      const url = new URL(href)
      url.hash = `#${anchorId}`
      const link = url.toString()

      copyTextToClipboard(link)
    }

    elements.forEach((element) => {
      element.addEventListener('click', copyLink)
    })

    return () => {
      elements.forEach((element) => {
        element.removeEventListener('click', copyLink)
      })
    }
  }, [content])

  useEffect(() => {
    const hash = window.location.hash

    if (hash) {
      const element = document.getElementById(hash.substring(1))
      if (element) {
        element.scrollIntoView()
      }
    }
  }, [content])
}
